import { render, staticRenderFns } from "./EventHubContent.vue?vue&type=template&id=44b94fc3"
import script from "./EventHubContent.vue?vue&type=script&lang=js"
export * from "./EventHubContent.vue?vue&type=script&lang=js"
import style0 from "./EventHubContent.vue?vue&type=style&index=0&id=44b94fc3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports